var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import history from 'helpers/History';
import { toMoney } from 'helpers/Format';
import { Table } from 'components';
import { loading } from '../../../elements/Loading';
var ArticlesTable = /** @class */ (function (_super) {
    __extends(ArticlesTable, _super);
    function ArticlesTable() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleSelectItem = function (article) {
            history.push("/articles/".concat(article.id));
        };
        _this.handleCreate = function () {
            history.push("/articles/create");
        };
        _this.formatArticles = function (articles) {
            return articles.map(function (article) { return (__assign(__assign({}, article), { price: toMoney(article.price, _this.props.store.moneysStore.getPrimaryMoney().alphabeticCode) })); });
        };
        return _this;
    }
    ArticlesTable.prototype.componentDidMount = function () {
        this.props.store.articles.read();
    };
    ArticlesTable.prototype.render = function () {
        var articles = this.props.store.articles;
        var businessUnits = this.props.businessUnits;
        var headers = ['code', 'name', 'price'];
        var filters = [
            {
                name: 'actives',
                filter: function (item) { return !item.disabled_at; }
            },
            {
                name: 'disabled',
                filter: function (item) { return item.disabled_at; }
            },
            {
                name: 'orphan',
                filter: function (item) { return !item.family_id; }
            },
            {
                name: 'all',
                filter: function (item) { return true; }
            }
        ];
        if (!(businessUnits.length > 0))
            return React.createElement("div", null,
                React.createElement("text", null, "No hay negocios dados de alta, por favor cree uno antes"),
                " ");
        return (React.createElement(Table, { items: this.formatArticles(articles.articles), header: headers, filters: filters, onSelectItem: this.handleSelectItem, onCreate: this.handleCreate, keyExtractor: function (article) { return String(article.id); }, loading: !articles.loaded }));
    };
    ArticlesTable = __decorate([
        inject('store'),
        loading(function (props) {
            return [
                props.store.businessUnits.read().then(function (businessUnits) { return ({ businessUnits: businessUnits }); }),
                props.store.moneysStore.read().then(function (moneys) { return ({ moneys: moneys }); })
            ];
        }),
        observer
    ], ArticlesTable);
    return ArticlesTable;
}(Component));
export default ArticlesTable;



//////////////////
// WEBPACK FOOTER
// ./src/modules/Articles/containers/ArticlesTable.tsx
// module id = 1555
// module chunks = 0